import * as React from 'react'

function SvgAccessoriesChecked(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path d="m32.293 8.293 1.414 1.414L28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 11c0-.26.011-.518.033-.773a3.223 3.223 0 0 0-2.8 1.546L9.68 24.046C8.347 26.212 9.905 29 12.448 29h15.105c2.542 0 4.1-2.788 2.768-4.954l-2.54-4.128a8.937 8.937 0 0 1-2.917-.922l3.753 6.098A1.25 1.25 0 0 1 27.562 27l-6.359-10.446.325-.534a8.964 8.964 0 0 1-1.05-2.12l-5.54 9.1h-2.266l6.264-10.178c.26-.423.71-.62 1.147-.592A9.08 9.08 0 0 1 20 11Zm-8.559 14-.058.094A1.25 1.25 0 0 0 12.448 27H25.22L24 24.994V25H11.441Zm8.592-6.524L22.786 23h-5.507l2.754-4.523Z"
      />
    </svg>
  )
}

export default SvgAccessoriesChecked
